export default __webpack_public_path__ + "static/media/ic_donate.eaea163c.svg";